import { createTheme } from '@mui/material/styles';

// Design tokens for the EWAS brand: deep forest ink, an ember-orange accent
// for fire, a frost-cyan accent for mountain/wildlife, warm paper for text.
export const tokens = {
  ink: '#0a1210',
  pine: '#111c18',
  pine2: '#16241f',
  contour: '#25382f',
  ember: '#e8763a',
  emberSoft: '#c96330',
  frost: '#7fd8d0',
  paper: '#eeece3',
  paperDim: 'rgba(238,236,227,0.62)',
  paperFaint: 'rgba(238,236,227,0.34)',

  display: '"Fraunces", Georgia, serif',
  body: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
  mono: '"IBM Plex Mono", "Courier New", monospace',
};

// hex -> rgba string, used by ElectricBorder instead of the oklch()
// relative-color syntax from the original snippet (patchy browser support).
export function hexToRgba(hex, alpha = 1) {
  const clean = hex.replace('#', '');
  const bigint = parseInt(clean.length === 3
    ? clean.split('').map((c) => c + c).join('')
    : clean, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgba(${r},${g},${b},${alpha})`;
}

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: tokens.ink,
      paper: tokens.pine,
    },
  },
  typography: {
    fontFamily: tokens.body,
  },
  shape: {
    borderRadius: 12,
  },
});

export default theme;
